
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {SellingReportList} from "../../models/sellingReportList";
import {TopSellerList} from "../../models/topSellerList";
import {Product} from "../../models/product";
import {SellingReport} from "../../models/sellingReport";
import {SellingReportItem} from "../../models/sellingReportItem";



@Injectable({ providedIn: 'root' })
export class SellingReportService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    get(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: SellingReportList) => {
                return x;
            }));
    }

    getTopSellersByDay(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling/top-sellers`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: TopSellerList) => {
                return x;
            }));
    }

    getTopSellersSummary(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling/top-sellers/summary`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: TopSellerList) => {
                return x;
            }));
    }

    getTopProducts(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling/products`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: TopSellerList) => {
                return x;
            }));
    }

    getTopVouchers(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling/vouchers`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: TopSellerList) => {
                return x;
            }));
    }

    getPaymentMethodsSummary(createdAt, createdAtTo) {
        return this.http.post(`${environment.apiEndpoint}/v1/reports/selling/payment-methods/summary`, {
            'createdAt': createdAt,
            'createdAtTo': createdAtTo
        }, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: SellingReportList) => {
                return x;
            }));
    }

    getProductTotalSummary(product: string) {
        return this.http.get(`${environment.apiEndpoint}/v1/reports/selling/payment-methods/total-summary/` + product + `/product`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: SellingReport) => {
                return x;
            }));
    }

    getProductTotalByYearSummary(product: string) {
        return this.http.get(`${environment.apiEndpoint}/v1/reports/selling/payment-methods/total-summary-by-year/` + product + `/product`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: SellingReportList) => {
                return x;
            }));
    }

    getSoldProductByDateAndWorker(createdAt, createdAtTo, product: string) {
        return this.http.get(`${environment.apiEndpoint}/v1/reports/selling/products-sold/by-date-and-worker/` + product + `/product/` + createdAt + `/` + createdAtTo, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map((x: SellingReportList) => {
                return x;
            }));
    }
}
